/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Detail_Keyword_GroupInputs */



/**
* | output |
* | --- |
* | "Detail Keyword Group" |
*
* @param {Subtitle_Export_Detail_Keyword_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_detail_keyword_group = /** @type {((inputs?: Subtitle_Export_Detail_Keyword_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Detail_Keyword_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de mots clés détaillés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Detail-Schlüsselwortgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di parole chiave dettagliate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Детальная группа ключевых слов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalle del grupo de palabras clave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("详细关键词组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("詳細キーワードグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विस्तृत कीवर्ड समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de palavras-chave detalhadas")
	return /** @type {LocalizedString} */ ("Detail Keyword Group")
});